/**
 * Page gestion des sessions actives
 * Wrapper autour du composant SessionsManager du module auth
 */

import { useAuth, SessionsManager } from '@features/auth';

export function SessionsSettingsPage() {
  const { user } = useAuth();

  if (!user) return null;

  return (
    <div className="flex justify-center">
      <SessionsManager
        userId={user.id}
        showRevokeAll={true}
      />
    </div>
  );
}
